import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

interface Props {
  displayIcon?: boolean;
}

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    content: {
      alignItems: "center",
      display: "flex",
      flexBasis: "fit-content",
      flexWrap: "wrap",
      columnGap: theme.spacing(12),
      rowGap: theme.spacing(6),
      width: "100%",
    },
    chartDataContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3.5),
    },
    filterValue: {
      color: theme.gray800,
      maxWidth: 100,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    filterSidebarValue: {
      color: theme.gray800,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    donutChartDescription: {
      display: "flex",
      flexDirection: "row",
      gap: "5px",
      margin: 0,
      fontSize: "14px",
    },
    bolder: { fontWeight: "bolder" },
    donutChart: {
      height: theme.spacing(11),
      width: theme.spacing(11),
    },
    filtersContainer: {
      alignItems: "baseline",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(6),

      "& .MuiFormHelperText-root.Mui-error": {
        display: "none",
      },
    },
    selectedFiltersContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(6),
      flexWrap: "wrap",
    },
    moreButton: {
      padding: theme.spacing(4.5),
    },
    tooltipInTable: {
      color: theme.gray400,
      height: theme.spacing(10),
      marginRight: theme.spacing(5),
      opacity: "0.5",
      width: theme.spacing(10),
    },
    filtersWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(5),
      marginBottom: theme.spacing(5),
      padding: theme.spacing(10),
    },
    btnWrapper: {
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(10),
    },
    addFilter: {
      maxWidth: "fit-content",
    },
    clearIcon: {
      height: "16px",
      width: "16px",
      minWidth: "16px",
      alignSelf: "center",
    },
    filterWrapper: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(5),
    },
    grayText: {
      color: theme.gray500,
      fontSize: 15,
      fontWeight: 500,
    },
    singleFilter: {
      border: `1px solid ${theme.gray100}`,
      cursor: "pointer",
      display: "flex",
      gap: theme.spacing(4),
      padding: theme.spacing(2, 5, 2, 5),
    },
    filterLabel: {
      display: "contents",
      fontSize: "15px",
      fontWeight: 500,
      lineHeight: "26px",
      whiteSpace: "nowrap",
    },
    inlineValue: {
      cursor: "pointer",
      fontSize: "15px",

      "& li": {
        whiteSpace: "nowrap",
      },
      "& .MuiInputBase-input": {
        padding: theme.spacing(0, 2),
      },
      "& .MuiInputBase-sizeSmall": {
        height: "24px !important",
        border: 0,
        padding: 0,
      },
      "& .MuiInputAdornment-root": {
        display: (props?: Props) => (props?.displayIcon ? "flex" : "none"),
        "& svg": {
          width: "18px",
        },
      },
      "& input": {
        fontSize: "15px",
        cursor: "pointer",
      },
      "& label": {
        display: "none",
      },
      "& fieldset": {
        border: 0,
      },
      "& .MuiIconButton-root": { marginRight: 0 },
    },
    inlineMultiWithModal: {
      "& .MuiChip-root": {
        height: "20px",
      },

      "& .MuiInputBase-sizeSmall": {
        minHeight: "24px",
        height: "unset !important",
        padding: "0 !important",
      },
    },
    filterBox: {
      border: `1px solid ${theme.gray200}`,
      borderRadius: "8px",
      padding: theme.spacing(5),
      justifyContent: "space-between",
      width: "100%",
      textTransform: "none",
      color: theme.gray800,
      boxShadow: "0px 1px 1px 0px #9A939340",
      textOverflow: "ellipsis",
    },
    sidebarBtn: {
      padding: theme.spacing(0),
      margin: theme.spacing(5, 0, 2),
      alignSelf: "end",
    },
    backBtn: {
      alignSelf: "start",
      "& svg": {
        width: "14px",
      },
    },
    filterSidebar: {
      gap: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    saveFilter: {
      marginTop: "auto",
    },
    sidebar: {
      width: "342px",
    },
    header: {
      padding: theme.spacing(4, 4, 4, 8),
      backgroundColor: theme.gray50,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    sidebarContent: {
      padding: theme.spacing(6),
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(6),
      height: "100%",
    },
    condition: {
      color: theme.gray500,
    },
    multiWithModal: {
      minWidth: "250px",
      "& .MuiChip-root": {
        height: "24px",
      },

      "& .MuiInputBase-sizeSmall": {
        minHeight: "40px",
        height: "unset !important",
      },
    },
    textWrapper: {
      minHeight: "40px",
      display: "flex",
      alignItems: "center",
    },
    tiersetDropdownWrapper: {
      minWidth: "200px",
    },
  }),
);
